

import React from 'react';
import {useTranslation} from "react-i18next";
import Section from "../basic/layouts/section";

function SectionStackTechnologies(props) {

    const { t, i18n } = useTranslation();

    //TODO: images local load + text (label for image)

    const stack = [
        'laravel',
        'flutter',
        'reactjs',
        'bootstrap',
        'mysql',
        'git'
    ];

    return (<div id={'stack-technologies'}>

        <Section title={''} name={''} child={<div className={'rounded-5 bg-dark text-white shadow-lg'}>

            <div className="container m-5 m-auto container p-5 text-start ">

                <div className="d-flex align-items-center">
                    <h5 className={'lead display-'}>
                        {t('subTitle.technologies')}
                        <span className={'p-1'}></span>
                    </h5>
                    <hr width={'80%'} style={{color: "white"}} />
                </div>

                <div className="d-flex flex-wrap mt-5 align-items-center">

                    <div id={'list-technologies'} className={'bg-white1 d-flex flex-wrap justify-content-between align-items-center p-1 pb-4'}>
                        {
                            stack.map((tech, i) =>  <div className={'col-md-2 col-2 text-center'}>
                                <img src={'/assets/img/stack/' + tech + '.png'} alt="Laravel" className={'img-fluid p-md-5 p-1 img-stack-technologies'}/>
                                <small className={'text-secondary'}>{tech}</small>
                            </div>)
                        }
                    </div>

                </div>

            </div>

        </div>} link={'/'} linkName={''}/>


    </div>);
}

export default SectionStackTechnologies;
